import { Button, Form, Input } from 'antd'
import { useForm } from 'antd/es/form/Form'
import React, { useContext } from 'react'
import { Color } from '../../../Common/Color'
import PublicContext from '../../PublicContext'
import { t } from 'i18next'

export default function ComputerConfirmSlotForm ({ initialValues, resendCode, onFinishFailed, onFinish }) {
  const { loading } = useContext(PublicContext)
  const [form] = useForm()

  return (
    <div style={{ display: 'flex', height: '-webkit-fill-available' }}>
      <Form
        style={{
          boxShadow: '0px 0px 2px 2px #f2f2f2',
          borderRadius: '1em',
          padding: '1em',
          textAlign: 'center',
          maxWidth: '270px',
          margin: 'auto'
        }}
        id="ConfirmSlotForm"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={initialValues}
      >
        <Form.Item name='start_timestamp' hidden>
          <Input />
        </Form.Item>
        <Form.Item name='end_timestamp' hidden>
          <Input />
        </Form.Item>
        <Form.Item name='calendar_id' hidden>
          <Input />
        </Form.Item>
        <Form.Item name='reason_id' hidden>
          <Input />
        </Form.Item>
        <Form.Item name='country' hidden>
          <Input />
        </Form.Item>
        <Form.Item name='civility' hidden>
          <Input />
        </Form.Item>
        <div style={{ fontWeight: 'bold', marginBottom: '1em' }}>
          {t('Public.ConfirmSlotForm.title')}
        </div>
        <Form.Item name="confirmation_code" style={{ width: '170px', margin: 'auto' }}
          rules={[{ required: true, message: t('rules.required') }]}>
          <Input onInput={e => { e.target.value = e.target.value.toUpperCase() }}
            style={{ textAlign: 'center', letterSpacing: '0.8em' }} placeholder="ERVKA" />
        </Form.Item>
        <a
          onClick={resendCode}
          style={{
            color: Color.red,
            textDecoration: 'underline',
            margin: '1em 0',
            display: 'block'
          }}>
          {t('Public.ConfirmSlotForm.resend')}
        </a>
        <Form.Item >
          <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
            {t('Public.ConfirmSlotForm.submitConfirmation')}
          </Button>
        </Form.Item>
      </Form >
    </div>
  )
}
